import React from "react"
import { OrderPaymentLedyer } from "lib/types/generated/graphql-types"
import {
  getPaymentMethodDisplayName,
  getPaymentProviderDisplayName
} from "helpers/getPaymentDisplayName"
import { Label } from "components/Ui/List/List"
import { Container, Row, StatusWrapper } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import StatusSmall from "../../../../../components/Ui/Status/StatusSmall"

type Props = {
  orderPayment: OrderPaymentLedyer
}

const Ledyer = ({ orderPayment }: Props) => {
  if (!orderPayment) return null
  return (
    <>
      <Container>
        <Row>
          <ListEntry
            label={"Payment provider"}
            value={getPaymentProviderDisplayName(orderPayment.providerName)}
          />{" "}
          <ListEntry
            label={"Payment method"}
            value={getPaymentMethodDisplayName(orderPayment.method)}
          />
          <ListEntry label={"Provider ID"} value={orderPayment.providerId} />
          <ListEntry label={"VAT ID"} value={orderPayment.vatId} />
          <ListEntry label={"Company name"} value={orderPayment.companyName} />
          <ListEntry label={"Company ID"} value={orderPayment.companyId} />
          <ListEntry label={"Payment reference"} value={orderPayment.reference} />
        </Row>
      </Container>
      <Container>
        <Row>
          <div>
            <Label>Payment status</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.status.toUpperCase()} />
            </StatusWrapper>
          </div>
        </Row>
      </Container>
    </>
  )
}

export default Ledyer
